// const generateQueryParameterString = (record: Record<string, string>) => {
//   const searchParams = new URLSearchParams()
//   Object.entries(record).map(([key, value], i) => {
//     if (value === undefined || value === null) {
//       return
//     }
//     searchParams.append(key, value)
//   })
//   return searchParams.toString()
// }

export const routes = {
  signInPath: () => '/sign_in',
  signOutPath: () => '/sign_out',
  tenantSelectPath: () => '/',

  // テナント毎
  termsOfUsePath: (tenantId: string) => `/t/${tenantId}/terms_of_use`,
  planConfirmPath: (tenantId: string) => `/t/${tenantId}/plan/confirm`,
  planCompletePath: (tenantId: string) => `/t/${tenantId}/plan/complete`,
  topPath: (tenantId: string) => `/t/${tenantId}/`,
  settingPath: (tenantId: string) => `/t/${tenantId}/setting`,
  usersPath: (tenantId: string) => `/t/${tenantId}/users`,
  invitationsPath: (tenantId: string) => `/t/${tenantId}/invitations`,
  // millsheetsPath: (tenantId: string) => `/t/${tenantId}/millsheets`,
  millsheetsUploadPath: (tenantId: string) => `/t/${tenantId}/millsheets/upload`,
  dashboardPath: (tenantId: string) => `/t/${tenantId}/dashboard`,

  // admin
  adminTenants: () => `/admin/tenants`,
  adminTenant: (id: string) => `/admin/tenants/${id}`,
  adminPlans: () => `/admin/plans`,
}
